import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { checkBoxCell, customCell, GridPanel, IRoutedTabProps } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../services/api/endpoint";
import { hasPermission } from "../../../services/authentication";
import { Permission } from "../../../utils/enums";
import ProvinceEditor from "../../editors/resources/province";

const Provinces: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.ProvincesList}
			endpoint={Endpoint.Provinces}
			addScreen={{ screen: ProvinceEditor, isAllowed: hasPermission(Permission.ProvincesAdd) }}
			editScreen={{ screen: ProvinceEditor, isAllowed: hasPermission(Permission.ProvincesUpdate) }}
			delete={{ isAllowed: hasPermission(Permission.ProvincesDelete) }}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="name" title={t("name")} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
		</GridPanel>
	);
};

export default Provinces;
